import { ResolvedComponent } from '../../routing/ResolvedComponent';
import { useAllowedActionsGuard } from '../../shared/hooks/useAllowedActionsGuard';
import { GlobalAction } from '../../shared/interfaces/allowed-actions';
import CreatePipeline from './CreatePipeline';

export default function CreatePipelineWithGuard() {
  const { executeAllowedActionsGuard } = useAllowedActionsGuard({
    actionType: GlobalAction.CREATE_PIPELINE,
    navigationRoute: '/pipeline',
    queryParams: { tab: 'edge' }
  });

  return (
    <ResolvedComponent Component={CreatePipeline} canActivate={[executeAllowedActionsGuard]} />
  );
}
